import { OnboardingStep, WorkBenefit } from '../../../types/GloblalTypes';
import OnboardingPageStrings from './OnboardingStrings';
import { ADMIN_MEMBERS, ADMIN_BILLING, ADMIN_BUDGETS, DASHPASS, } from '../../../utils/admin_helper';
var getChecklistItemsForExpensedMeals = function (completedSteps) {
    if (completedSteps === void 0) { completedSteps = []; }
    return [
        {
            key: OnboardingStep.ONBOARDING_STEP_ADD_MEMBER,
            title: OnboardingPageStrings.checklistAddEmployees(),
            subtext: OnboardingPageStrings.expensedMeals.checklistAddEmployeesSubtext(),
            isCompleted: completedSteps.includes(OnboardingStep.ONBOARDING_STEP_ADD_MEMBER),
            toSubpage: ADMIN_MEMBERS,
        },
        {
            key: OnboardingStep.ONBOARDING_STEP_ADD_PAYMENT_METHOD,
            title: OnboardingPageStrings.checklistAddPayment(),
            subtext: OnboardingPageStrings.expensedMeals.checklistAddPaymentSubtext(),
            isCompleted: completedSteps.includes(OnboardingStep.ONBOARDING_STEP_ADD_PAYMENT_METHOD),
            toSubpage: ADMIN_BILLING,
        },
        {
            key: OnboardingStep.ONBOARDING_STEP_ADD_BUDGET,
            title: OnboardingPageStrings.checklistAddBudget(),
            subtext: OnboardingPageStrings.checklistAddBudgetSubtext(),
            isCompleted: completedSteps.includes(OnboardingStep.ONBOARDING_STEP_ADD_BUDGET),
            toSubpage: ADMIN_BUDGETS,
        },
    ];
};
var getChecklistItemsForExpensedMealsInvoicing = function (completedSteps) {
    if (completedSteps === void 0) { completedSteps = []; }
    return [
        {
            key: OnboardingStep.ONBOARDING_STEP_ADD_MEMBER,
            title: OnboardingPageStrings.checklistAddEmployees(),
            subtext: OnboardingPageStrings.expensedMeals.checklistAddEmployeesSubtext(),
            isCompleted: completedSteps.includes(OnboardingStep.ONBOARDING_STEP_ADD_MEMBER),
            toSubpage: ADMIN_MEMBERS,
        },
        {
            key: OnboardingStep.ONBOARDING_STEP_ADD_BUDGET,
            title: OnboardingPageStrings.checklistAddBudget(),
            subtext: OnboardingPageStrings.checklistAddBudgetSubtext(),
            isCompleted: completedSteps.includes(OnboardingStep.ONBOARDING_STEP_ADD_BUDGET),
            toSubpage: ADMIN_BUDGETS,
        },
    ];
};
var getChecklistItemsForDashPass = function (completedSteps) {
    if (completedSteps === void 0) { completedSteps = []; }
    return [
        {
            key: OnboardingStep.ONBOARDING_STEP_ADD_MEMBER,
            title: OnboardingPageStrings.checklistAddEmployees(),
            subtext: OnboardingPageStrings.dashPass.checklistAddEmployeesSubtext(),
            isCompleted: completedSteps.includes(OnboardingStep.ONBOARDING_STEP_ADD_MEMBER),
            toSubpage: ADMIN_MEMBERS,
        },
        {
            key: OnboardingStep.ONBOARDING_STEP_ADD_PAYMENT_METHOD,
            title: OnboardingPageStrings.checklistAddPayment(),
            subtext: OnboardingPageStrings.dashPass.checklistAddPaymentSubtext(),
            isCompleted: completedSteps.includes(OnboardingStep.ONBOARDING_STEP_ADD_PAYMENT_METHOD),
            toSubpage: ADMIN_BILLING,
        },
        {
            key: OnboardingStep.ONBOARDING_STEP_ACTIVATE_DASHPASS,
            title: OnboardingPageStrings.dashPass.checklistActivate(),
            subtext: OnboardingPageStrings.dashPass.checklistActivateSubtext(),
            isCompleted: completedSteps.includes(OnboardingStep.ONBOARDING_STEP_ACTIVATE_DASHPASS),
            toSubpage: DASHPASS,
        },
    ];
};
export var getChecklistItems = function (completedSteps, isExpensedMealInvoicing, workBenefit) {
    if (completedSteps === void 0) { completedSteps = []; }
    if (isExpensedMealInvoicing) {
        return getChecklistItemsForExpensedMealsInvoicing(completedSteps);
    }
    if (workBenefit === WorkBenefit.WORK_BENEFIT_DASHPASS) {
        return getChecklistItemsForDashPass(completedSteps);
    }
    return getChecklistItemsForExpensedMeals(completedSteps);
};
export var targetOnboardingStepsForDashPass = [
    OnboardingStep.ONBOARDING_STEP_ADD_MEMBER,
    OnboardingStep.ONBOARDING_STEP_ADD_PAYMENT_METHOD,
    OnboardingStep.ONBOARDING_STEP_ACTIVATE_DASHPASS,
];
export var targetOnboardingStepsForExpensedMeals = [
    OnboardingStep.ONBOARDING_STEP_ADD_MEMBER,
    OnboardingStep.ONBOARDING_STEP_ADD_PAYMENT_METHOD,
    OnboardingStep.ONBOARDING_STEP_ADD_BUDGET,
];
export var checkAllPageStepsCompleted = function (adminCompletedSteps, workBenefit) {
    var setOfSteps = new Set(adminCompletedSteps);
    if (workBenefit === WorkBenefit.WORK_BENEFIT_DASHPASS) {
        return targetOnboardingStepsForDashPass.every(function (s) { return setOfSteps.has(s); });
    }
    return targetOnboardingStepsForExpensedMeals.every(function (s) { return setOfSteps.has(s); });
};
